import {
  AlertTriangle,
  Bell,
  Pencil,
  RotateCcw,
  Trash,
  Trash2,
} from 'lucide-react';
import type { ActionDef, ActionProps } from './creator-action-types';

export type { ActionDef, ActionProps } from './creator-action-types';

const ERR = 'hover:text-error';
const PRIM = 'hover:text-text-primary';

function sanction(p: ActionProps): ActionDef {
  const show = !!(p.canSanction && p.onSanction);
  return {
    key: 's',
    label: 'Sancionar',
    Icon: AlertTriangle,
    hoverCls: ERR,
    onClick: p.onSanction,
    show,
  };
}
function alert(p: ActionProps): ActionDef {
  const show = !!(p.canAlert && p.onAlert);
  return {
    key: 'a',
    label: 'Alertar',
    Icon: Bell,
    hoverCls: PRIM,
    onClick: p.onAlert,
    show,
  };
}
function edit(p: ActionProps): ActionDef {
  return {
    key: 'e',
    label: 'Editar',
    Icon: Pencil,
    hoverCls: PRIM,
    onClick: p.onEdit,
    show: p.canEdit ?? true,
  };
}
function restore(p: ActionProps): ActionDef {
  const show = !!(p.canRestore && p.onRestore);
  return {
    key: 'r',
    label: 'Restaurar',
    Icon: RotateCcw,
    hoverCls: PRIM,
    onClick: p.onRestore,
    show,
  };
}
function softDelete(p: ActionProps): ActionDef {
  return {
    key: 'd',
    label: 'Eliminar',
    Icon: Trash2,
    hoverCls: ERR,
    onClick: p.onDelete,
    show: p.canDelete ?? true,
  };
}
function hardDelete(p: ActionProps): ActionDef {
  const show = !!(p.canHardDelete && p.onHardDelete);
  return {
    key: 'h',
    label: 'Eliminar permanentemente',
    Icon: Trash,
    hoverCls: ERR,
    onClick: p.onHardDelete,
    show,
  };
}

export function buildActions(p: ActionProps): ActionDef[] {
  return [
    alert(p),
    sanction(p),
    edit(p),
    restore(p),
    softDelete(p),
    hardDelete(p),
  ];
}
